import JoinPartnerProgram from '@/components/join-partner-program';

export default JoinPartnerProgram;
